import React from 'react';
import * as S from './styles';
import { Detalhe, Resumo } from './types';

const GRUPOS = [3, 4, 5, 8, 9, 10, 14, 15, 16];

export function Table({ data, visaoResumo }: Readonly<{ data: Resumo; visaoResumo: string }>): JSX.Element {
  const formatTableRow = (item: Detalhe, index: number) => {
    const isPercentual = item.descricao.descricao.includes('%');

    const formatValue = (value?: number) => {
      if (value == null) return '-';
      return value.toLocaleString('pt-br');
    };

    const prefix = item.descricao.descricao.includes('R$') ? 'R$ ' : '';
    const sufix = isPercentual ? '%' : '';

    return (
      <tr
        key={item.id}
        style={{
          background: GRUPOS.includes(index) ? '#008c90' : 'white',
          color: GRUPOS.includes(index) ? 'white' : 'black',
        }}
      >
        <td>{item.descricao.descricao}</td>
        <td>{prefix + formatValue(item.valorMensalAluguel) + sufix}</td>
        <td>{prefix + formatValue(item.valorMensalCondominio) + sufix}</td>
        <td>{prefix + formatValue(item.valorMensalFundo) + sufix}</td>
        <td>{prefix + formatValue(item.valorMensalComerciais) + sufix}</td>
        <td>{prefix + formatValue(item.valorAnualAluguel) + sufix}</td>
        <td>{prefix + formatValue(item.valorAnualCondominio) + sufix}</td>
      </tr>
    );
  };

  return (
    <S.TableContainer>
      <thead>
        <tr>
          <th rowSpan={2}>RESUMO</th>
          <th colSpan={4}>{visaoResumo.toUpperCase()}</th>
          <th colSpan={2}>INADIMPLÊNCIA YTD</th>
        </tr>
        <tr>
          <th>ALUGUEL</th>
          <th>CONDOMÍNIO</th>
          <th>FUNDO</th>
          <th>COMERCIAIS</th>
          <th>ALUGUEL</th>
          <th>CONDOMÍNIO</th>
        </tr>
      </thead>
      <tbody>{data.map(formatTableRow)}</tbody>
    </S.TableContainer>
  );
}
